'use client';

import { BrowserUtils } from '~/utils/BrowserUtils';

export const formatShortcutKey = (key: string) => {
  switch (key) {
    case 'meta':
      return BrowserUtils.isMacOS() ? '⌘' : 'ctrl';
    case 'left':
      return '←';
    case 'right':
      return '→';
    case 'up':
      return '↑';
    case 'down':
      return '↓';
    case 'shift':
      return '⇧';
    case 'alt':
      return BrowserUtils.isMacOS() ? '⌥' : 'alt';
    case 'enter':
      return '↵';
    case 'plus':
      return '+';
    case 'minus':
      return '-';
    default:
      return key;
  }
};

export const SEARCH_COMMAND_OPEN_HOTKEYS = 'meta+p,ctrl+p,meta+k,ctrl+k';

export const formatMetaKeyChord = (key: string) => {
  const modifier = formatShortcutKey('meta');

  if (BrowserUtils.isMacOS()) {
    return `${modifier}${key}`;
  }

  return `${modifier}+${key}`;
};
